export default {
    testimonials:state=>state.testimonials,
    agent:state=>state.agent,
    agentid:state=>state.agentid
};
